











import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { refreshTokenAction } from "./store/user/action-types";
import { wexinAuthReq } from "@/helper/weChatHelper";
import WechatBarcode from "@/shared/wechatBarcode.vue";
import { resetUserInfo } from "@/store/user/mutation-types";
import { resetHomeState } from "@/store/home/mutation-types";

const UserModule = namespace("user");
const HomeModule = namespace("home");

@Component({
  components: {
    WechatBarcode
  }
})
export default class App extends Vue {
  @UserModule.Action(refreshTokenAction) refreshToken: any;
  @UserModule.Mutation(resetUserInfo) reset: any;
  @HomeModule.Mutation(resetHomeState) resetHomeState: any;

  @UserModule.State("loaded") loaded: any;
  @UserModule.State("miniappBarcodePath") barcodePath: any;

  created() {
    this.refreshToken().catch((error: any) => {
      if (
        error &&
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        wexinAuthReq();
      } else {
        console.log(error);
      }
    });
  }

  beforeDestroy() {
    this.reset();
    this.resetHomeState();
  }
}
